// phonics_data_lt23.js
// Letter Teams L23 - L23 R controlled Vowels ar, or Bossy r
// 路由：/phonics/lt23

const MEDIA_BASE = '/media/phonics/lt23';
const V = 'v1';

export const letterDataLt23 = {
  id: 'lt23',
  letter: 'L23',
  title: 'L23 R controlled Vowels ar, or Bossy r',
  mediaBase: MEDIA_BASE,

  part1Video: { src: `${MEDIA_BASE}/part1.mp4?${V}` },
  part3Video: { src: `${MEDIA_BASE}/part3.mp4?${V}` },
  reviewPic: { src: `${MEDIA_BASE}/review.png?${V}` },

  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "The pals drive on the road.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "Stop the car!", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "I see Mark!", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "Can you give me a ride?", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "Yes! Get in the car.", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: "Please take me north.", audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
        { en: "The car goes north.", audioEn: `${MEDIA_BASE}/story1_7.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "Oh no! It is a storm!", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "Look, there is a farm.", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "And I see a barn!", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "The pals and Mark run.", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "It's too far!", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "I see a horse.", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
        { en: "They ride the horse.", audioEn: `${MEDIA_BASE}/story2_7.mp3?${V}` },
        { en: "They come to the barn.", audioEn: `${MEDIA_BASE}/story2_8.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "Wow! There is so much corn!", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "Let's eat!", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "Soon the storm stops.", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "Let's go back to the road.", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
      ],
    },
  ],
};
